import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { Core2Config } from "../../shared/core2Config";
import { StockLevelMonitoringRunFiLabelHdrLinkModel } from "../../../../../../models/aggregates/erp/stock/stock-level-monitoring-run-fi-label-hdr-link.model";

@Injectable({ providedIn: "root" })
export class StockLevelMonitoringRunFiLabelHdrLinkService extends BaseApiTemplateService<StockLevelMonitoringRunFiLabelHdrLinkModel> {
  readonly url =
    Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 
    "stock-level-monitoring-run-fi-label-hdr-links/" + Core2Config.BACKOFFICE_EP_SUFFIX;

  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "stock-level-monitoring-run-fi-label-hdr-links/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + "stock-level-monitoring-run-fi-label-hdr-links/" + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = theHttp;
  }
}
